import React, { useState, useEffect, useMemo } from "react";
import { Dropzone, useDropzone } from "react-dropzone";
import { Button, Modal } from "react-bootstrap";
import "./ProfileImageModal.scss";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage";
const ProfileImageModal = (props) => {
  /**Dropzone styling */
  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#eeeeee",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#bdbdbd",
    outline: "none",
    transition: "border .24s ease-in-out",
    cursor: "pointer",
  };

  const activeStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };

  /**Preview styling */
  const thumbsContainer = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 16,
  };

  const thumb = {
    display: "inline-flex",
    borderRadius: 2,
    border: "1px solid #eaeaea",
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: "border-box",
  };

  const thumbInner = {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
  };

  const img = {
    display: "block",
    width: "auto",
    height: "100%",
    cursor: "pointer",
  };

  const [files, setFiles] = useState([]);

  const [selectedFile, setSelectedFile] = useState();

  const fileupload = async (selectedFile) => {
    if (selectedFile) {
      props.upload(selectedFile);
      props && props.setDisableSave(true);
    }
  };

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: "image/*",
    multiple: false,
    onDrop: (acceptedFiles) => {
      setSelectedFile(acceptedFiles[0]);
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );
  const thumbs = files.map((file) => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img src={file.preview} style={img} />
      </div>
    </div>
  ));

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file) => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  //For croping
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const saveImageCropped = async (img) => {
    try {
      const croppedImage = await getCroppedImg(
        img,
        croppedAreaPixels,
        rotation
      );
      setCroppedImage(croppedImage);
      fetch(croppedImage)
        .then((response) => response.blob())
        .then((blobData) => {
          // Convert Blob to File (optional)
          const file = new File([blobData], "image.jpg", {
            type: "image/jpeg",
          });

          // Upload the Blob or File to your desired destination (e.g., Amazon S3 or a server)
          if (file) {
            props.upload(file);
            props && props.setDisableSave(true);
          }
        })
        .catch((error) => {
          console.error("Error fetching Blob data:", error);
        });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Modal
      show={props.show}
      animation={false}
      size="lg"
      className="profile-upload-popup"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Button type="button" className="close" onClick={props.onHide}>
          <span aria-hidden="true">
            <img
              src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
              alt="closeicon"
              className="close"
            />
          </span>
          <span className="sr-only">Close</span>
        </Button>
        <Modal.Title id="contained-modal-title-vcenter">
          Profile Picture Upload
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <section className="container">
          {props && props.fileUploadError && (
            <p className="error">{props.fileUploadError.error.image[0]}</p>
          )}
          <div {...getRootProps({ style })}>
            <input {...getInputProps()} />
            <i className="fa fa-upload fa-4x" aria-hidden="true"></i>
            <p>Drag 'n' drop or select your profile picture</p>
            <p>Please keep your profile picture size to 200x200</p>
          </div>
          {files.map((file) => (
            <div style={thumb} key={file.name}>
              <div style={thumbInner}>
                {/* <img src={file.preview} style={img} /> */}
                <div className="crop-container">
                  <Cropper
                    image={file.preview}
                    crop={crop}
                    zoom={zoom}
                    rotation={rotation}
                    aspect={1 / 1}
                    onCropChange={setCrop}
                    onRotationChange={setRotation}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                  />
                </div>
              </div>
            </div>
          ))}
          {/* <aside style={thumbsContainer}>{thumbs}</aside> */}
        </section>
      </Modal.Body>
      <Modal.Footer className="profile_image_modal_footer">
        {/* {props && props.disableSave ? (
          <Button variant="secondary">Save</Button>
        ) : (
          <Button variant="success" onClick={(e) => fileupload(selectedFile)}>
            Save
          </Button>
        )} */}
        <div className="w-75">
          <span>Zoom</span>
          <div>
            <input
              type="range"
              value={zoom}
              min={1}
              max={3}
              step={0.1}
              aria-labelledby="Zoom"
              onChange={(e) => {
                setZoom(e.target.value);
              }}
              className="zoom-range"
            />
          </div>
          <div>
            <span>Rotate</span>
            <input
              type="range"
              value={rotation}
              min={0}
              max={360}
              step={1}
              aria-labelledby="Rotation"
              onChange={(e) => setRotation(e.target.value)}
              className="zoom-range"
            />
          </div>
          {files.map((file) => (
            <div>
              <Button
                variant="success"
                onClick={(e) => saveImageCropped(file.preview)}
              >
                Save
              </Button>
            </div>
          ))}
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default ProfileImageModal;
